<template>
  <b-container fluid id="register-container">
    <b-row class="h-100">
      <b-col lg="5" offset-lg="1" class="py-5">
        <b-container>
          <img src="@/assets/images/rush-logo-new.svg" alt="RUSH">
          <RegistrationFormVue />
        </b-container>
      </b-col>
      <b-col lg="6" id="self-serve-right" class="d-flex flex-column p-0">
        <div id="bg-top" class="w-100"></div>
        <b-container>
          <div class="d-flex flex-column align-items-center justify-content-center p-4 h-100">
            <h1 class="text-center mb-5">Here's what you can do with the RUSH Platform:</h1>
            <div id="features" class="mx-auto w-100">
              <VueSlickCarousel v-bind="carouselSettings" ref="carousel">
                <div class="feature-item p-5 d-flex flex-column flex-md-row align-items-center justify-content-center"
                  v-for="(feature, featureIndex) in whatYouCanDo" :key="`feature-${featureIndex}`">
                  <div class="feature-img mr-0 mr-md-5 mb-5 mb-md-0">
                    <img :src="feature.img" :alt="feature.title">
                  </div>
                  <div class="feature-content">
                    <h2 class="mb-3"> {{ feature.title }} </h2>
                    <p class="mb-0"> {{ feature.description }} </p>
                  </div>
                </div>
              </VueSlickCarousel>
              <div class="arrow-container w-100 mt-5">
                <div class="mx-auto w-50 d-flex align-items-center justify-content-between">
                  <b-button @click="navigateCarouselArrow('prev')" class="arrow-prev shadow-none"></b-button>
                  <b-button @click="navigateCarouselArrow('next')" class="arrow-next shadow-none"></b-button>
                </div>
              </div>
            </div>
          </div>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import RegistrationFormVue from "@/components/RegistrationForm";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  components: { RegistrationFormVue, VueSlickCarousel },
  data() {
    return {
      whatYouCanDo: [
        { title: 'Mobilize your own customer channel', description: 'Get a custom-branded website, app, or marketplace storefront that can be accessed by your customers anytime, anywhere.', img: require('@/assets/images/feature-icon/feat-mobilize-your-loyalty-program.svg') },
        { title: 'Craft the perfect customer experience', description: 'Manage an easy-to-use Content Management System (CMS) to add stores, build your catalogue, offer payment and delivery options, and more.', img: require('@/assets/images/feature-icon/feat-craft-the-perfect-custom-experience.svg') },
        { title: 'Engage Your Customers', description: 'Communicate with your preferred audiences via multiple channels such as SMS, e-mail blasts, and pop-up banners.', img: require('@/assets/images/feature-icon/feat-engage-your-customers.svg') },
        { title: 'Gain Customer Insights', description: 'Understand consumer behavior, acquire insights, and make data-driven campaigns with RUSH’s analytics platform.', img: require('@/assets/images/feature-icon/feat-gain-customer-insights.svg') },
        { title: 'Become an eCommerce / Loyalty expert', description: 'Get full support access to member-only workshops and events to help your business thrive online.', img: require('@/assets/images/feature-icon/feat-become-a-loyalty-expert.svg') }
      ],
      carouselSettings: {
        arrows: false,
        dots: true,
        autoplay: true
      }
    }
  },
  methods: {
    navigateCarouselArrow(direction) {
      this.$refs.carousel[direction]();
    }
  },
  created() {
    this.$gtag.event("registration_page_load", {
      "event_category": "Registration",
      "event_label": "Registration Page Load"
    });
  }
}
</script>
<style lang="scss" scoped>
#register-container {
  height: 100vh;
  #self-serve-right {
    #bg-top {
      height: 168px;
      background: url('~@/assets/images/self-serve-registration-bg-top.svg') no-repeat top left / cover;
    }
    background: #FFF;
    background-image: url('~@/assets/images/self-serve-registration-bg.svg');
    background-image: url('~@/assets/images/self-serve-registration-bg.svg'), linear-gradient(#FFF, #FFF 50%, #F9F9F9 50%, #F9F9F9);
    background-size: cover;
    background-position: bottom right;
    background-repeat: no-repeat;
    h1 {
      font-size: 32px;
      line-height: 45px;
      color: #2F3941;
      max-width: 507px;
    }
    #features {
      max-width: 537px;
      margin-bottom: 120px;
      .feature-item {
        min-height: 208px;
        .feature-content {
          h2 {
            font-family: "SKModernistBold", sans-serif;
            font-size: 22px;
            line-height: 24px;
            color: #2F3941;
          }
          p {
            font-family: SKModernist, sans-serif;
            font-size: 16px;
            line-height: 24px;
            color: #87929D;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
#features {
  .slick-list {
    background: white;
    border-radius: 15px;
    box-shadow: 0px 4px 28px rgba(0, 0, 0, 0.09);
  }
  .slick-dots {
    bottom: -80px;
    li button:before {
      font-size: 13px;
      color: #2F4858;
    }
  }
  .arrow-container {
    z-index: 1;
    position: relative;
    margin-top: 65px !important;
    .arrow-prev, .arrow-next {
      border: 0;
      padding: 0;
      width: 13px;
      height: 7px;
    }
    .arrow-prev {
      background: url('~@/assets/images/caret-down.svg') no-repeat center;
      transform: rotate(90deg);
    }
    .arrow-next {
      background: url('~@/assets/images/caret-down.svg') no-repeat center;
      transform: rotate(-90deg);
    }
  }
}
</style>
